import React, { Component } from "react";

interface SearchBoxProps {
  title: string;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  additionalClasses?: string;
  idSuffix?: string;
  value?: string;
}

class SearchBox extends Component<SearchBoxProps, {}> {
  render() {
    const { additionalClasses, title, onSearch, placeholder, idSuffix, ...rest } = this.props;
    return (
      <div className="input-icon">
        <input
          type="text"
          className={"form-control " + additionalClasses}
          placeholder={placeholder}
          id={"kt_datatable_search_query" + (idSuffix ? idSuffix : "")}
          name={"searchbox" + (idSuffix ? idSuffix : "")}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onSearch(e)}
          {...rest}
        />
        <span>
          <i className="fa fa-search text-muted" title={title} />
        </span>
      </div>
    );
  }
}

export default SearchBox;
